import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";

const ButtonGroup = ({ buttons }) => {
  const theme = useTheme();

  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Box display="flex" flexWrap={isMediumScreen ? "wrap" : "nowrap"} gap={1}>
      {buttons.map((button, index) => (
        <Box
          key={index}
          display="flex"
          alignItems="center"
          justifyContent="center"
          width={{ xs: "auto", sm: "auto" }}
          borderRadius="99px"
          border={`1px solid ${darkColors.buttonTop}`}
          px={isMediumScreen ? 2.7 : 2}
          py={0.5}
          sx={{ cursor: "pointer" }}
          onClick={button.onClick} // Call the onClick callback
        >
          <Typography
            color={darkColors.wagerGray}
            fontSize={fontSizes.heading3}
            fontStyle="italic"
          >
            {button.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default ButtonGroup;
